// extracted by mini-css-extract-plugin
export var inactive = "tab-panel-module--inactive--9f1be";
export var title = "tab-panel-module--title--adabe";
export var titleSelected = "tab-panel-module--titleSelected--83962";